import '/app/brewery-packages/content/content-editor-plugin-title/src/Title.css-raw';
export default {
  "title": "about-us-b998e096-title--87Tha"
};